import FieldProto from './field-proto';

import _ from 'lodash';

export default class CustomFieldProto extends FieldProto {

    constructor(customField) {
        super();
        this.customField = customField;
    }

    get label() {
        return this.customField.name;
    }

    get description() {
        return gd.const.customFields[this.customField.type].description;
    }

    get sortHintMessage() {
        return 'Sort by ' + this.customField.name;
    }

    get systemIcon() {
        return gd.const.customFields[this.customField.type].icon;
    }

    get systemTypeName() {
        return gd.const.customFields[this.customField.type].label;
    }

    get groupId() {
        return this.customField.id;
    }

    get groupLabel() {
        return this.customField.name;
    }

    get groupInfo() {
        return 'Group by ' + this.customField.name;
    }

    getValue(item) {
        return item.customFieldsData ? item.customFieldsData[this.customField.id] : null
    }

    getValueType() {
        return this.customField.valueType;
    }

    get fieldId() {
        return this.customField.id;
    }

    get label() {
        return this.customField.name;
    }

    get icon() {
        return gd.const.customFields[this.customField.type].icon;
    }

    get defaultWidth() {return 200} // default column width


    getGroupObject(value) {
        return {
            id: !_.isNil(value) ? value : null,
            customFieldId: this.customField.id,
            value: !_.isNil(value) ? value : null,
        }
    }

    normalizeCSVValue(value) {
        console.error(this.customField.type+" getValueFromCSV not implemented");
        return value;
    }
}
